export const SUB_MENU_DIRECTION = {
  TOPLEFT: 'topLeft',
  TOPCENTER: 'topCenter',
  TOPRIGHT: 'topRight',
  BOTTOMLEFT: 'bottomLeft',
  BOTTOMCENTER: 'bottomCenter',
  BOTTOMRIGHT: 'bottomRight',
  MIDDLELEFT: 'middleLeft',
  MIDDLERIGHT: 'middleRight',
} as const;

export type SUB_MENU_DIRECTION_KEY = keyof typeof SUB_MENU_DIRECTION;
export type SUB_MENU_DIRECTION_VALUE = typeof SUB_MENU_DIRECTION[SUB_MENU_DIRECTION_KEY];

export const SUB_MENU_DIRECTION_MAP = {
  [SUB_MENU_DIRECTION.TOPLEFT]: '왼쪽 위',
  [SUB_MENU_DIRECTION.TOPCENTER]: '위쪽 중앙',
  [SUB_MENU_DIRECTION.TOPRIGHT]: '오른쪽 위',
  [SUB_MENU_DIRECTION.MIDDLELEFT]: '왼쪽 중앙',
  [SUB_MENU_DIRECTION.MIDDLERIGHT]: '오른쪽 중앙',
  [SUB_MENU_DIRECTION.BOTTOMLEFT]: '왼쪽 아래',
  [SUB_MENU_DIRECTION.BOTTOMCENTER]: '아래쪽 중앙',
  [SUB_MENU_DIRECTION.BOTTOMRIGHT]: '오른쪽 아래',
};

export const subMenuDirectionList = Object.keys(SUB_MENU_DIRECTION_MAP).map((key) => {
  return {
    key: key,
    value: SUB_MENU_DIRECTION_MAP[key],
  };
});

// 서브메뉴 플렉스 방향 설정
export const SUB_MENU_FLEX_DIRECTION = {
  ROW: 'row',
  COLUMN: 'column',
} as const;

export type SUB_MENU_FLEX_DIRECTION_KEY = keyof typeof SUB_MENU_FLEX_DIRECTION;
export type SUB_MENU_FLEX_DIRECTION_VALUE = typeof SUB_MENU_FLEX_DIRECTION[SUB_MENU_FLEX_DIRECTION_KEY];

export const SUB_MENU_FLEX_DIRECTION_MAP = {
  [SUB_MENU_FLEX_DIRECTION.ROW]: '가로 배치',
  [SUB_MENU_FLEX_DIRECTION.COLUMN]: '세로 배치',
};

export const subMenuFlexDirectionList = Object.keys(SUB_MENU_FLEX_DIRECTION_MAP).map((key) => {
  return {
    key: key,
    value: SUB_MENU_FLEX_DIRECTION_MAP[key],
  };
}); 